import { pushAnalyticsObjToDataLayer } from "@/utils/helper"
import {
  FIND_MY_ORDER_NUMBER,
  ORDER_STATUS,
} from "@/components/Shared/OrderStatus/v1/analytics/constant"

const addFindMyOrderAnalytics = params => {
  const { status, action, errorMessage, link, buttonLabel } = params
  const eventInfo = getEventInfo(
    "order status",
    buttonLabel,
    null,
    status,
    true,
    errorMessage,
    link
  )
  sessionStorage.setItem("searches", eventInfo.searchCount)
  const { adobeDataLayer: { getState } = {} } = window
  const page =
    action === "cmp:show"
      ? window.pageObj
      : (getState && getState("page")) || {}
  window.adobeDataLayer.push({
    event: action,
    eventInfo,
    page,
  })
  delete window.pageObj
}

const getEventInfo = (
  text1,
  text2,
  text3,
  status,
  needsJSON = false,
  errorsList,
  link
) => {
  let errorMsg
  if (status && status !== "success" && errorsList?.length) {
    errorMsg = errorsList.join("|").toLowerCase()
  }
  const eventInfo = {
    eventAction: `my account:orders:${text1}:${text2}`,
    eventName: `my account:orders:${text1}:${text2}`,
    eventType:
      text2 === "call support phone number" ? "help support" : "navigation",
    eventMsg: errorMsg || "n/a",
    eventStatus: status || "n/a",
    internalLinkName: text3 === null ? text2 : text3,
    internalLinkPosition: "my order",
    internalLinkType: "my account:navigation",
    internalLinkZoneName: `my account:orders:${text1}`,
    internalLinkURL: text3 === null ? link || "n/a" : "tel:" + text3,
    clickInternalLinks: "true",
  }
  if (needsJSON) {
    return eventInfo
  }
  return JSON.stringify(eventInfo)
}

const getRecaptchaOrderStatusAnalytics = {
  pageTitle: "my account:orders:order status",
  componentName: "order status",
  parentComponent1: "orders",
  parentComponent2: "my account",
  internalLinkPosition: "my order",
  internalLinkType: "my account:navigation",
}

const handleHelpTextAnalytics = () => {
  const eventInfo = getEventInfo(
    ORDER_STATUS,
    FIND_MY_ORDER_NUMBER,
    null,
    null,
    true
  )
  pushAnalyticsObjToDataLayer(eventInfo, "cmp:click")
}

export {
  addFindMyOrderAnalytics,
  getEventInfo,
  getRecaptchaOrderStatusAnalytics,
  handleHelpTextAnalytics,
}
